export const getConsentMode = () => {
  let granted;

  const consentManagement =
    (window.dataLayer || [])
      .filter((item) => item[0] === 'consent' && item[1] === 'update')
      .map((item) => item[2])
      .pop() || {};

  if (Object.values(consentManagement).length) {
    granted = Object.values(consentManagement).filter((value) => value === 'granted').length >= 1;
  }

  if (!granted) {
    const {
      ics: {
        entries: { ad_personalization = {}, ad_storage = {}, ad_user_data = {}, analytics_storage = {} } = {},
      } = {},
    } = window.google_tag_data || {};

    const hasValue = (obj = {}) => obj.update !== undefined;

    if (hasValue(ad_personalization) || hasValue(ad_storage) || hasValue(ad_user_data) || hasValue(analytics_storage)) {
      granted =
        Object.values({ ad_personalization, ad_storage, ad_user_data, analytics_storage }).filter(
          (value = {}) => value.update,
        ).length >= 1;
    }
  }

  return granted;
};
